import { empty } from "./functions"
import { createEvent, restore } from "effector";
import { setAppAndroidLink, setAppIOSLink, setUserAgreementLink } from "./config/vars";
import { setSiteColors } from "./config/company-atts";
import { setAccessDeniedIntfs } from "./disabledInterfaces";
import { companies, getCompanyBySegment, getCompanyByUserAgent, getDefaultCompany } from "./config/companies";

// Custom-User-Agent конкретной компании берём из единого конфига (config/companies.ts).
const uaOf = (key: string) =>
  (companies.find((c) => c.key === key) || getDefaultCompany()).userAgent;

// Определяем текущую компанию по первому сегменту URL и выставляем её User-Agent.
export function setCustomUserAgent() {
  let pathname = window.location.pathname
  if (!empty(pathname)) {
    let pathArr = pathname.split("/")
    if (pathArr.length > 1) {
      const company = getCompanyBySegment(pathArr[1])
      setCurrentAppCustomUserAgent(company.userAgent)
    }
  }
}

export const getCustomUserAgent = () => {
  if (empty($currentAppCustomUserAgent.getState())) setCustomUserAgent()
  return $currentAppCustomUserAgent.getState()
}

export const getCustomUserAgentKrk = () => $appCustomUserAgentKrk.getState()
export const getCustomUserAgentJKHInfo = () => $appCustomUserAgentJKHInfo.getState()
export const getCustomUserAgentASB = () => $appCustomUserAgentASB.getState()
export const getCustomUserAgentOirc = () => $appCustomUserAgentOirc.getState()

export const setAppCustomUserAgentKrk = createEvent<string>();
export const $appCustomUserAgentKrk = restore<string>(setAppCustomUserAgentKrk, uaOf("krk"));


export const setAppCustomUserAgentJKHInfo = createEvent<string>();
export const $appCustomUserAgentJKHInfo = restore<string>(setAppCustomUserAgentJKHInfo, uaOf("izba"));


export const setAppCustomUserAgentASB = createEvent<string>();
export const $appCustomUserAgentASB = restore<string>(setAppCustomUserAgentASB, uaOf("asb"));

export const setAppCustomUserAgentOirc = createEvent<string>();
export const $appCustomUserAgentOirc = restore<string>(setAppCustomUserAgentOirc, uaOf("oirc"));


export const setCurrentAppCustomUserAgent = createEvent<string>();
export const $currentAppCustomUserAgent = restore<string>(setCurrentAppCustomUserAgent, "");

// При смене текущей компании применяем её ссылки, отключённые интерфейсы и тему из конфига.
$currentAppCustomUserAgent.watch((currState) => {
  const company = getCompanyByUserAgent(currState)
  if (!company) return
  setAppIOSLink(company.iosLink)
  setAppAndroidLink(company.androidLink)
  setUserAgreementLink(company.userAgreementLink)
  setAccessDeniedIntfs(company.disabledInterfaces)
  setSiteColors(company.colors)
})
